import React from 'react';
import {useTranslation} from 'react-i18next';
import cx from 'classnames';

import {FontVariant, Row, Text} from '@pexip/components';
import type {MediaDeviceInfoLike} from '@pexip/media-control';

import {PlayingBackDeviceSelection} from './PlayingBackDeviceSelection.view';

import styles from './MicrophoneMonitorModal.module.scss';

export const PlayingBack: React.FC<
    React.PropsWithChildren<{
        audioInputs: MediaDeviceInfoLike[];
        audioOutputs: MediaDeviceInfoLike[];
        selectedAudioInput?: MediaDeviceInfoLike;
        selectedAudioOutput?: MediaDeviceInfoLike;
        onAudioInputChange: (device: MediaDeviceInfoLike) => void;
        onOutputInputChange: (device: MediaDeviceInfoLike) => void;
        tryAgain?: () => void;
    }>
> = ({
    audioInputs,
    audioOutputs,
    children,
    selectedAudioInput,
    selectedAudioOutput,
    onOutputInputChange,
    onAudioInputChange,
    tryAgain,
}) => {
    const {t} = useTranslation();

    return (
        <div>
            <Row className={cx('mt-2', styles.playbackDescriptionRow)}>
                <Text fontVariant={FontVariant.H6}>
                    {t(
                        'media.this-is-how-you-will-sound-to-others',
                        'This is how you will sound to others',
                    )}
                </Text>
            </Row>
            {children}
            <Row className="mt-2">
                <PlayingBackDeviceSelection
                    audioInputs={audioInputs}
                    audioOutputs={audioOutputs}
                    selectedAudioInput={selectedAudioInput}
                    selectedAudioOutput={selectedAudioOutput}
                    onOutputInputChange={onOutputInputChange}
                    onAudioInputChange={onAudioInputChange}
                    tryAgain={tryAgain}
                />
            </Row>
        </div>
    );
};
